var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Podium"},_vm._l((_vm.places),function(place,i){return _c('PodiumPlace',_vm._b({key:i},'PodiumPlace',place,false))}),1)}
var staticRenderFns = []

export { render, staticRenderFns }